(function () {
  'use strict';

  var prefetched = new Set();

  function canPrefetch() {
    var connection = navigator.connection;
    return !connection || (!connection.saveData && !/2g/.test(connection.effectiveType || ''));
  }

  function prefetchLink(event) {
    if (!canPrefetch()) return;

    var anchor = event.target.closest('a[href]');
    if (!anchor) return;

    var url = new URL(anchor.href, location.href);
    if (url.origin !== location.origin || url.hash || prefetched.has(url.href)) return;
    if (!/^\/(collections|products|pages|policies|search)(\/|\?|$)/.test(url.pathname)) return;

    prefetched.add(url.href);
    var hint = document.createElement('link');
    hint.rel = 'prefetch';
    hint.href = url.href;
    document.head.appendChild(hint);
  }

  document.addEventListener('pointerover', prefetchLink, { passive: true, capture: true });
  document.addEventListener('touchstart', prefetchLink, { passive: true, capture: true });

  document.querySelectorAll('img').forEach(function (image, index) {
    if (!image.hasAttribute('decoding')) image.decoding = 'async';
    if (index > 1 && !image.hasAttribute('loading') && !image.classList.contains('lazyload')) {
      image.loading = 'lazy';
    }
  });
})();
